export default {"src":"/_next/static/media/whatsapp.fac282e3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};